export { GeneratedActivityResults, type GeneratedActivityResultsProps } from "./GeneratedActivityResults"
